import { useData } from "./DataContext.js";
import { style } from "./Style.js";

import { BsFillClockFill } from "react-icons/bs";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Badge from "react-bootstrap/Badge";

export default function TimeFormat (props)
{
    const gData = useData();
    if (gData.state.currentThemeId === null) return (<></>);
    
    let min = props.value % 60;
    let hour = (props.value - min) / 60;
    if (hour < 10) hour = "0"+hour;
    if (min < 10) min = "0"+min;

    const themeContent = gData.content.themes[gData.state.currentThemeId];

    const timeLeft = themeContent.endTime - gData.state.time;
    const minLeft = timeLeft % 60;
    const hourLeft = (timeLeft - minLeft) / 60;

    const minLeftStr = minLeft + " minute" + (minLeft > 1 ? "s" : "");
    const hourLeftStr = hourLeft + " heure" + (hourLeft > 1 ? "s" : "");
    const timeLeftStr = (hourLeft > 0 ? hourLeftStr : "")
		      + (hourLeft > 0 & minLeft > 0 ? " et " : "")
		      + (minLeft > 0 ? minLeftStr : "");

    let bgColor = "light";
    let borderColor = "dark";
    let textColor = "text-dark";
    let clockColor = "text-dark";
    
    if (timeLeft > 60) { clockColor = "text-light"; textColor = "text-dark"; bgColor = "dark"; borderColor = "dark"; }
    else if (timeLeft > 0) { clockColor = "text-dark"; textColor = "text-dark"; bgColor = "warning"; borderColor = "warning"; }
    else { clockColor = "text-light"; textColor = "text-dark"; bgColor = "danger"; borderColor = "danger"; }

    const timeStr = timeLeft <= 0 ?
	      (
		  <span className="fw-medium text-white">{gData.content.themes[gData.state.currentThemeId].timeoutMessage || "C'est l'heure de rendre votre rapport !"}</span>
	      ) :
	      (
		  <span>
		      <span>Il vous reste </span>
		      <span className={"fw-bold " + textColor}>{timeLeftStr}</span><br/>
		      <span>avant de rendre votre rapport.</span>
		  </span>
	      );

    const popover = (
	<Popover className={style.popover.className} style={{ width: "400px", maxWidth: "400px" }}>
	    <Popover.Body className={style.popover.body.className + "fs-5"}>
		{timeStr}
	    </Popover.Body>
	</Popover>
    );

    return (
	<OverlayTrigger placement="bottom" overlay={popover}>
	    <Badge bg={bgColor} className={"border border-1 border-"+borderColor+" user-select-none d-flex align-items-center gap-2"}>
		<div className={"fs-4 " + clockColor}><BsFillClockFill/></div>
		<div className="fw-bold fs-3 d-flex align-items-center gap-1">
		    <div className={clockColor}>{hour}</div>
		    <div className={clockColor}>:</div>
		    <div className={clockColor}>{min}</div>
		</div>
		{/* <span className="opacity-0">🕑</span> */}
		{/* <span className="ps-1 pb-2 fs-6 text-secondary"><BsInfoCircle/></span> */}
	    </Badge>
	</OverlayTrigger>
    );
}
